import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import './Hobby.css';
import { FaInstagram, FaPlay, FaPause } from 'react-icons/fa';

function Hobby() {
    const [isPlaying, setIsPlaying] = useState(true);

    return (
        <>
            <SectionHeader index="07" label="Off the record" title="Beyond the spec" />
            <div className="hobby-container">
                <div className="hobby-text-side reveal">
                    <p className="hobby-desc">
                        When I'm not shipping, I'm singing. It's the same discipline in a
                        different medium: listen to the audience, iterate on the delivery,
                        perform under pressure.
                    </p>
                    <dl className="hobby-meta">
                        <div className="hobby-meta-row">
                            <dt>Role</dt>
                            <dd>Vocalist &amp; performer</dd>
                        </div>
                        <div className="hobby-meta-row">
                            <dt>Handle</dt>
                            <dd>@t4nm4y__music</dd>
                        </div>
                    </dl>
                    <a
                        href="https://www.instagram.com/t4nm4y__music/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-doc btn-doc--accent"
                    >
                        <FaInstagram /> Listen on Instagram
                    </a>
                </div>

                <div className="hobby-visual-side reveal">
                    {/* Vinyl player */}
                    <div className="vinyl-wrapper">
                        <div className={`vinyl-record ${isPlaying ? 'spinning' : ''}`}>
                            <div className="vinyl-grooves"></div>
                            <div className="vinyl-label">
                                <div className="vinyl-logo">T.R</div>
                            </div>
                        </div>

                        <div className="vinyl-sleeve">
                            <div className="sleeve-content">
                                <div className="track-info">
                                    <span className="label mono-label">B-side · now playing</span>
                                    <h3>Tanmay's Choice</h3>
                                    <p>@t4nm4y__music</p>
                                </div>

                                <div className="player-controls">
                                    <button
                                        className="play-btn"
                                        onClick={() => setIsPlaying(!isPlaying)}
                                        aria-label={isPlaying ? 'Pause' : 'Play'}
                                    >
                                        {isPlaying ? <FaPause /> : <FaPlay />}
                                    </button>
                                    <div className="waveform">
                                        {[...Array(10)].map((_, i) => (
                                            <div key={i} className={`bar ${isPlaying ? 'animating' : ''}`} style={{ animationDelay: `${i * 0.1}s` }}></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Hobby;
